import dayjs, { ConfigType } from "dayjs";

export type RepeatType = "day" | "week" | "month";

export function computeRepeatCountFromUntil({
  startDate,
  untilDate,
  interval,
  type,
}: {
  startDate: ConfigType;
  untilDate: ConfigType;
  interval: number | null | undefined;
  type: RepeatType;
}): number {
  const start = dayjs(startDate).startOf("day");
  const until = dayjs(untilDate).startOf("day");

  if (!until.isValid() || until.isBefore(start)) return 1;

  const step = Math.max(1, interval || 1);
  let count = 1;
  let occurrence = start.add(step, type);
  while (!occurrence.isAfter(until)) {
    count++;
    occurrence = occurrence.add(step, type);
  }
  return count;
}
